(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-02"] && !Shopify.designMode) return;
  try {
    function initProductCardSlider(slider) {
    const track = slider.querySelector('.product-card-track');
    const slides = slider.querySelectorAll('.product-card-slide');
    const nextBtn = slider.querySelector('.slider-arrow.next');
    const prevBtn = slider.querySelector('.slider-arrow.prev');
    let current = 0;

    /* --------------------------
     MOVE SLIDER
  --------------------------- */
    const goToSlide = (index) => {
      track.style.transition = 'transform 0.4s ease';
      track.style.transform = `translateX(-${index * 100}%)`;
      current = index;
    };

    /* --------------------------
     NEXT (infinite loop)
  --------------------------- */
    const nextSlide = (e) => {
      e.stopPropagation();

      if (current === slides.length - 1) {
        track.style.transition = 'none';
        track.style.transform = `translateX(${100}%)`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            goToSlide(0);
          });
        });
      } else {
        goToSlide(current + 1);
      }
    };

    /* --------------------------
     PREV (infinite loop)
  --------------------------- */
    const prevSlide = (e) => {
      e.stopPropagation();

      if (current === 0) {
        track.style.transition = 'none';
        track.style.transform = `translateX(-${slides.length * 100}%)`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            goToSlide(slides.length - 1);
          });
        });
      } else {
        goToSlide(current - 1);
      }
    };

    /* Attach Events */
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);

    // Initial slide load
    goToSlide(0);
  }

  window.initProductCardSlider = initProductCardSlider;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-slider]').forEach(initProductCardSlider);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-color-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('[data-color-swatch-link]');
    if (!link) return;

    event.preventDefault();
    window.location.replace(link.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-item-size"] && !Shopify.designMode) return;
  try {
    if (!window.productItemSizeClickReady) {
    window.productItemSizeClickReady = true;

    document.addEventListener('click', function (e) {
      let target = e.target.closest('.size-item a[data-quickshop-popup]');
      if (!target) return; // agar click kisi aur jagah hua to ignore

      e.preventDefault();

      let selectedValue = target.getAttribute('title'); // jaise "S", "M", "L"
      let productHandle = target.getAttribute('data-product-handle');

      console.log('Clicked Size:', selectedValue, 'Product:', productHandle);

      // Wait karo jab tak quickshop popup open na ho jae
      setTimeout(() => {
        let input = document.querySelector(`input.product-form__radio[name="Size"][value="${selectedValue}"]`);

        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true })); // Shopify ko change event mil jae
          console.log(`✅ Size "${selectedValue}" checked ho gaya.`);
        } else {
          console.warn(`⚠️ Input not found for size "${selectedValue}".`);
        }
      }, 700); // popup load hone ka delay (Ella me 600–800ms sahi rehta hai)
    });
  }
  } catch(e) { console.error(e); }
})();

})();
